/*
 * DP24 Quick add
 * Any button with [data-pbn-quick-add][data-variant-id] adds that variant to the cart
 * without leaving the page, lets Horizon re-render the cart drawer via
 * CartLinesUpdateEvent, then opens the drawer so the shopper sees the bundle progress.
 */

const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

function openCartDrawer() {
  const component = document.querySelector('cart-drawer-component');
  if (component && typeof component.open === 'function') {
    component.open();
    return;
  }
  const drawer = document.getElementById('cart-drawer');
  if (drawer && typeof drawer.showDialog === 'function') {
    drawer.showDialog();
    return;
  }
  const dialog = drawer && drawer.querySelector('dialog');
  if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
}

async function quickAdd(button) {
  const label = button.querySelector('[data-label]');
  const original = label ? label.textContent : '';
  const variantId = Number(button.dataset.variantId);
  if (!variantId) return;

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  if (label) label.textContent = 'Adding…';

  const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);

  let events = null;
  let deferred = null;
  try {
    events = await import('@shopify/events');
    deferred = events.CartLinesUpdateEvent.createPromise();
    button.dispatchEvent(
      new events.CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: `gid://shopify/ProductVariant/${variantId}`, quantity: 1 }],
        promise: deferred.promise,
      })
    );
  } catch (e) {
    deferred = null;
  }

  try {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || 'Could not add to cart');

    if (deferred) {
      let cart = null;
      let itemCount;
      try {
        const cartJson = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
        itemCount = cartJson.item_count;
        cart = events.CartLinesUpdateEvent.createCartFromAjaxResponse
          ? events.CartLinesUpdateEvent.createCartFromAjaxResponse(cartJson)
          : cartJson;
      } catch (e) {}
      deferred.resolve({
        cart,
        detail: { sections: data.sections || undefined, items: data.items, itemCount, source: 'pbn-quick-add', didError: false },
      });
    }

    if (label) label.textContent = 'Added \u2713';
    button.classList.add('is-added');
    setTimeout(openCartDrawer, 250);
    setTimeout(() => {
      if (label) label.textContent = original;
      button.classList.remove('is-added');
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }, 2500);

    if (!deferred) window.location.reload();
  } catch (error) {
    console.warn('[pbn-quick-add]', error);
    if (deferred) deferred.reject(error);
    button.disabled = false;
    button.removeAttribute('aria-busy');
    if (label) label.textContent = 'Try again';
  }
}

if (!window.__pbnQuickAddBound) {
  window.__pbnQuickAddBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pbn-quick-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    quickAdd(button);
  });
}
